import { gsap, SplitText, ScrollTrigger } from "@gsap";
/**
 * Layout: Hero - Home
 * Slug: hero_home
 */

function toggleMute(video, controls) {
	video.muted = !video.muted;
	controls.classList.toggle("muted", video.muted);
	controls.classList.toggle("unmuted", !video.muted);
}
function togglePlayback(video, controls) {
	video.paused ? video.play() : video.pause();
	controls.classList.toggle("paused", video.paused);
	controls.classList.toggle("playing", !video.paused);
}

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.hero_home-layout');

	layouts.forEach((layout) => {
		let mm = gsap.matchMedia();
		const videoWrapper = layout.querySelector(".video-wrapper");
		const videoControls = layout.querySelector(".video-controls");
		const video = layout.querySelector(".video-wrapper video");

		if(video) {
		const videoControls = layout.querySelector(".video-controls");
			const volumeControl = videoControls.querySelector(".volume");
			const playbackControl = videoControls.querySelector(".play-pause");
			volumeControl.addEventListener("click", () => toggleMute(video, videoControls));
			playbackControl.addEventListener("click", () => togglePlayback(video, videoControls));
		}

		mm.add("(min-width: 993px)", () => {
			gsap.to(videoWrapper, {
				padding: 0,
				scrollTrigger: {
					trigger: layout,
					scrub: 1,
					start: "top top+=150",
					end: "center top+=150",
					markers: false,
					onUpdate: () => {
						ScrollTrigger.refresh();
					}
				}
			});
			gsap.to(videoControls, {
				right: 24,
				scrollTrigger: {
					trigger: layout,
					scrub: 1,
					start: "top top+=150",
					end: "center top+=150",
					markers: false,
					onUpdate: () => {
						ScrollTrigger.refresh();
					}
				}
			});
		});
	});
});
